// React
import React from "react";

// Third party imports
import { motion } from "framer-motion";

export default function AnimationWrapper({ children }) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      // No height/overflow: the shells (MainLayout, ClientPortalLayout) own the page scroll
    >
      {children}
    </motion.div>
  );
}
